<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属经销商" name="company_name" readonly @click="$refs.stationedSelector.open(2)"></c-form-item>
					<c-form-item type="input" label="退款单号" name="return_number"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="用户名" name="login_name"></c-form-item>
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="退款单状态" name="return_state" :options="returnState" ></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="return_state"
					width="90"
				>
					<template v-slot="{data}">
						<span style="color:#182eff" v-if="data.return_state==1">{{orderStateName[data.return_state]}}</span>
						<span style="color:dodgerblue" v-if="data.return_state==2">{{orderStateName[data.return_state]}}</span>
						<span style="color:dodgerblue" v-if="data.return_state==3">{{orderStateName[data.return_state]}}</span>
						<span style="color:darkgreen" v-if="data.return_state==5">{{orderStateName[data.return_state]}}</span>
						<span style="color:#999999" v-if="data.return_state==6">{{orderStateName[data.return_state]}}</span>
						<span style="color:#999999" v-if="data.return_state==8">{{orderStateName[data.return_state]}}</span>
					</template>
				</c-table-column>
						
				<c-table-column
					label="退货单号"
					name="return_number"
					width="130"
				></c-table-column>
				
				<c-table-column
					label="经销商名称"
					name="stationed_name"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="订单号"
					width="120"
					name="order_number"
				></c-table-column>
				
				<c-table-column
					label="收货状态"
					name="receiving_state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.return_state == 3 || data.return_state == 5">
							<span v-if="data.receiving_state==0"><span style="color:#182eff">待收货</span></span>
							<span v-if="data.receiving_state==1"><span style="color:darkgreen">已收货</span></span>
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="下单用户"
					name="nick_name"
					width="200"
				>
					  <template v-slot="{data}">
						<span>{{data.user_manage_mobilephone}}</span>
						<span v-if="data.nick_name && data.nick_name!=''">({{data.nick_name}})</span>
					  </template>
				</c-table-column>
				
				<c-table-column
					label="退货数量"
					name="product_count"
				></c-table-column>
				
				<c-table-column
					label="商品金额"
					name="product_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.product_money&&data.product_money>0">￥{{data.product_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="运费金额"
					name="logistics_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.logistics_money&&data.logistics_money>0">￥{{data.logistics_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="扣款金额"
					name="debit_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.debit_money&&data.debit_money>0">￥{{data.debit_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="实退金额"
					name="return_total_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.return_total_money&&data.return_total_money>0">￥{{data.return_total_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="150"
				></c-table-column>
						
				<c-table-column
					label="审核时间"
					name="audit_date"
					width="150"
				>
				  <template v-slot="{data}">
					<span v-if="data.audit_date">{{data.audit_date}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="寄回物流公司"
					name="return_logistics_company"
					width="150"
				>
				</c-table-column>
				
				<c-table-column
					label="寄回物流单号"
					name="return_logistics_number"
					width="150"
				>
				</c-table-column>
						
				<c-table-column
					label="打款到账时间"
					name="remitter_date"
				  width="150"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					width="80"
					label="操作"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/return_detail/${data.return_number}`)">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_seller_order_return',
		
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},

        props: {
            return_state: String
        },

		data() {
			return {
				orderStateName: {
					1: '待审核',
					2: '待用户退货',
					3: '待财务打款',
					5: '退款成功',
					6: '已驳回',
					8: '已撤销'
				},
				returnState: [{
						name: '待审核',
						value: 1
					},{
						name: '待用户退货',
						value: 2
					},{
						name: '待财务打款',
						value: 3
					},{
						name: '退款成功',
						value: 5
					},{
						name: '已驳回',
						value: 6
					},{
						name: '已撤销',
						value: 8
					}
				]
			}
		},

        computed: {
			...mapState(['systemConfig']),
            defaultSearch() {
                let param = {
                    return_state: this.return_state ? this.return_state.split(',') : [],
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('return.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 2;
				this.$refs.table.load({
					url: '/returns/list',
					data
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>